export { default } from "./useGetUser";
export * from "./useGetUser";
